import state from './modulePaymentStatusManagementState.js'
import mutations from './modulePaymentStatusManagementMutations.js'
import actions from './modulePaymentStatusManagementActions.js'
import getters from './modulePaymentStatusManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

